import React from 'react';
import { motion } from 'framer-motion';
import { contactInfo, socialLinks } from '../../data/portfolioData';
import { Mail, Phone, Linkedin, FileText } from 'lucide-react';

const Contact: React.FC = () => {
  const getContactIcon = (type: string) => {
    switch (type) {
      case 'email':
        return <Mail size={24} />;
      case 'phone':
        return <Phone size={24} />;
      default:
        return <Mail size={24} />;
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Contact
        </motion.h2>
        
        <div className="contact-info">
          {contactInfo.map((item, index) => (
            <motion.div
              key={item.id}
              className="contact-item"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              {getContactIcon(item.type)}
              <p>{item.value}</p>
            </motion.div>
          ))}
          
                     {/* LinkedIn Contact Item */}
           <motion.div
             className="contact-item linkedin-contact"
             initial={{ opacity: 0, y: 30 }}
             whileInView={{ opacity: 1, y: 0 }}
             transition={{ duration: 0.8, delay: 0.4 }}
             viewport={{ once: true }}
             whileHover={{ y: -5 }}
           >
             <Linkedin size={24} />
             <a 
               href="https://www.linkedin.com/in/shristi-subedi-8814b7266/" 
               target="_blank" 
               rel="noopener noreferrer"
               className="linkedin-link"
             >
               Connect on LinkedIn
             </a>
           </motion.div>

           {/* CV Download Contact Item */}
           <motion.div
             className="contact-item cv-download"
             initial={{ opacity: 0, y: 30 }}
             whileInView={{ opacity: 1, y: 0 }}
             transition={{ duration: 0.8, delay: 0.5 }}
             viewport={{ once: true }}
             whileHover={{ y: -5 }}
           >
             <FileText size={24} />
             <a 
               href="/cv-shristi-subedi.pdf" 
               className="cv-link"
               download="Shristi_Subedi_CV.pdf"
               target="_blank"
               rel="noopener noreferrer"
             >
               Download CV
             </a>
           </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
